module.exports = __webpack_public_path__ + "static/media/Info.3ad97a60.svg";